import { render, staticRenderFns } from "./SingoReport1.vue?vue&type=template&id=5a819df8&scoped=true"
import script from "./SingoReport1.vue?vue&type=script&lang=js"
export * from "./SingoReport1.vue?vue&type=script&lang=js"
import style0 from "./SingoReport1.vue?vue&type=style&index=0&id=5a819df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a819df8",
  null
  
)

export default component.exports